import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Release a body scroll lock that outlived the dialog that set it.
 *
 * MUI's modal manager pins `overflow: hidden` (plus a scrollbar-width padding)
 * on `<body>` while a Dialog is open and restores it on close. Nested dialogs
 * that unmount together — the course paywall opening the shared checkout, for
 * one — can unmount in an order that skips the restore, and the page is then
 * dead to the wheel until a reload clears the inline style.
 *
 * Runs on every navigation and only when no modal is mounted, so it can never
 * unlock the page underneath a dialog that is legitimately open.
 */
const useReleaseStaleScrollLock = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (document.querySelector('.MuiModal-root')) return;
    const { body } = document;
    if (body.style.overflow !== 'hidden') return;
    body.style.removeProperty('overflow');
    body.style.removeProperty('padding-right');
  }, [pathname]);
};

export default useReleaseStaleScrollLock;
